export default __webpack_public_path__ + "static/media/align.1c2ad15b.svg";